import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import toolsSnapshot from '../../data/tools-snapshot.json';
import toolLandingPages, { getToolName } from '../../data/toolLandingPages';

// Plain crawlable links to every other landing page — spreads internal
// link equity so Google discovers and indexes all /rent/<slug> pages.
export default function MoreToolsLinks({ excludeIds = [] }) {
  const { t, language, lp } = useLanguage();
  const tools = (Array.isArray(toolsSnapshot) ? toolsSnapshot : [])
    .filter((tool) => toolLandingPages[tool.id]?.slug && !excludeIds.includes(tool.id));

  if (tools.length === 0) return null;

  return (
    <section className="mb-8">
      <h2 className="text-lg font-bold text-black mb-3">{t('toolLandingPage.moreToolsTitle')}</h2>
      <ul className="grid grid-cols-1 lg:grid-cols-2 gap-x-6 gap-y-1 list-none p-0 m-0">
        {tools.map((tool) => (
          <li key={tool.id}>
            <Link
              to={lp(`/rent/${toolLandingPages[tool.id].slug}`)}
              state={{ fromApp: true }}
              className="flex justify-between gap-3 py-2 border-b border-gray-100 text-[14px] text-gray-700 no-underline hover:text-black"
            >
              <span>{getToolName(tool, language)}</span>
              {tool.pricePerDay > 0 && (
                <span className="text-dewalt font-bold whitespace-nowrap">
                  {t('rentPage.fromPrice')} {tool.pricePerDay} {t('rentPage.perDay')}
                </span>
              )}
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
